import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModalComponent } from './loading-modal.component';

@Injectable({
  providedIn: 'root'
})
export class LoadingModalService {
  constructor(private modal: NgbModal) { }

  private readonly modalOptions: NgbModalOptions = {
    centered: true,
    backdrop: false,
    windowClass: 'rek-loading-modal'
  };

  private modalRef: NgbModalRef;

  open(title: string, subtitle: string, dissmissOthers?: boolean): void {
    if (dissmissOthers) {
      this.modal.dismissAll();
    }

    this.modalRef = this.modal.open(LoadingModalComponent, this.modalOptions);
    this.modalRef.componentInstance.title = title;
    this.modalRef.componentInstance.subtitle = subtitle;
  }

  close(): void {
    this.modalRef.close();
  }
}
